/** Dashboard type index of the Agenda panel (see DashboardService.getPanelTypes). */
export const AGENDA_DASHBOARD_TYPE = 15;

export interface DashboardEntity {
  DashboardID: number;
  Variable: number;
  GroupBy: number;
  Type: number;
  Position: number;
  Filter: any | null;
  Title: string;
  Data: string | null;
  DashboardPanelID: number;
  MaxItems: number | null;
  DashboardPersonDays: number | null;
  categoryValues?: string[];
}
